import { render, staticRenderFns } from "./PerformerMembers.vue?vue&type=template&id=f4df0d28&"
import script from "./PerformerMembers.vue?vue&type=script&lang=js&"
export * from "./PerformerMembers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports